import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play, ChevronDown } from 'lucide-react';
import { stats } from '../data/mock';
import wcomLogo from "../assets/wcomLogo.png";
import neuralBg from "../assets/neural-bg.png";


const HeroSection = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-slate-950">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-cyan-900/20 via-slate-950 to-slate-950" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-teal-900/10 via-transparent to-transparent" />
        
        {/* Grid Pattern */}
        <div 
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(6, 182, 212, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(6, 182, 212, 0.3) 1px, transparent 1px)`,
            backgroundSize: '60px 60px'
          }}
        />
        
        {/* Floating Elements */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-500/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 mb-8">
              <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" />
              <span className="text-cyan-400 text-sm font-medium">+ de 30 anos de experiência</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Vantagens{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400">
                competitivas
              </span>{' '}
              para a sua empresa
            </h1>

            <p className="text-lg text-slate-400 mb-8 max-w-xl leading-relaxed">
              Acreditamos na Tecnologia da Informação como patrimônio estratégico das Organizações.
              Geramos vantagens competitivas com inteligência e adesão aos seus negócios.
            </p>

            <div className="flex flex-wrap gap-4 mb-12">
              <Button
                onClick={() => scrollToSection('#contact')}
                className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-400 hover:to-teal-400 text-slate-900 font-semibold px-8 py-6 text-base shadow-lg shadow-cyan-500/25 hover:shadow-cyan-500/40 transition-all duration-300 group"
              >
                Iniciar Projeto
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                variant="outline"
                onClick={() => scrollToSection('#services')}
                className="border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-white px-8 py-6 text-base transition-all duration-300 group"
              >
                <Play className="mr-2 h-4 w-4" />
                Nossos Serviços
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center sm:text-left">
                  <div className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400">
                    {stat.value}
                  </div>
                  <div className="text-sm text-slate-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Visual Element */}
          <div className="relative hidden lg:block">
            <div className="relative w-full aspect-square">
              {/* Main Circle */}
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-cyan-500/10 to-teal-500/10 border border-cyan-500/20" />
              
           {/* Inner Circle */}
<div className="absolute inset-0 rounded-full overflow-hidden border border-cyan-500/30 bg-slate-900">

  {/* Background neural nítido */}
  <img
    src={neuralBg}
    alt=""
    className="absolute inset-0 w-full h-full object-cover"
  />

  {/* Overlay leve (opcional) */}
  <div className="absolute inset-0 bg-slate-900/15" />

  

</div>

              
              {/* Orbiting Elements */}
              <div className="absolute top-8 right-8 w-16 h-16 rounded-xl bg-slate-800/80 backdrop-blur border border-cyan-500/20 flex items-center justify-center animate-float">
                <span className="text-cyan-400 text-2xl font-bold">&lt;/&gt;</span>
              </div>
              <div className="absolute bottom-16 left-4 w-14 h-14 rounded-xl bg-slate-800/80 backdrop-blur border border-teal-500/20 flex items-center justify-center animate-float" style={{ animationDelay: '0.5s' }}>
                <span className="text-teal-400 text-xl">{`{}`}</span>
              </div>
              <div className="absolute top-1/2 -left-4 w-12 h-12 rounded-full bg-slate-800/80 backdrop-blur border border-cyan-500/20 flex items-center justify-center animate-float" style={{ animationDelay: '1s' }}>
                <span className="text-cyan-400">★</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('#about')}
          className="flex flex-col items-center gap-2 text-slate-500 hover:text-cyan-400 transition-colors"
        >
          <span className="text-xs uppercase tracking-widest">Scroll</span>
          <ChevronDown className="h-5 w-5" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
